import { render, staticRenderFns } from "./VatList.vue?vue&type=template&id=4215c16a"
import script from "./VatList.vue?vue&type=script&lang=js"
export * from "./VatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports